import axios from './api';
import { getUrl } from './utils';

const endPoint = getUrl('api') + '/api/v1/laboratory'; //TODO MIGRATE

export const saveLaboratory = async (body) => {
  return axios
    .post(endPoint, body)
    .then((res) => res)
    .catch((error) => error.response);
};

export const getLaboratory = (id) =>
  axios
    .get(endPoint.concat('/', id), {})
    .then((res) => res)
    .catch((error) => error.response);

export const updateLaboratory = (laboratory) =>
  axios
    .put(endPoint.concat('/', laboratory.id), laboratory, {})
    .then((res) => res)
    .catch((error) => error.response);
